import { GetJobDetails } from '@/api/fe-api/view/queries/capacity-evalution/get-job-details';
import { Card } from '@/components/ui/card';
import { LoadError } from '@/components/ui/load-error';
import { Loading } from '@/components/ui/old/Loading';
import { useCurrentAsset } from '@/hooks/use-current-asset';

import { CapacityTestMetadata } from './capacity-test-metadata';
import { CapacityTestResults } from './capacity-test-results';
import { SectionSohChart } from './section-soh-chart';

export type CapacityTestDetailsProps = { selectedId: string };
export function CapacityTestDetails({ selectedId }: CapacityTestDetailsProps) {
  const jobDetails = GetJobDetails.useQuery({ id: selectedId });
  const { asset } = useCurrentAsset();

  if (jobDetails.isLoading) {
    return <Loading />;
  }

  if (!jobDetails.data?.isOk()) {
    return (
      <LoadError title="An error occurred while loading the test details" />
    );
  }

  return (
    <div className="space-y-4">
      <Card>
        <CapacityTestMetadata data={jobDetails.data.value} />
      </Card>
      {asset ? (
        <>
          <Card>
            <SectionSohChart
              capacityTest={jobDetails.data.value}
              asset={asset}
            />
          </Card>
          <CapacityTestResults
            jobDetails={jobDetails.data.value}
            asset={asset}
          />
        </>
      ) : null}
    </div>
  );
}
